//1/421,686.7469879518 = 0.000002371428571
import './css/Rechner.scss';

import StoryFramework from 'storyframework-ts';
import Database from './Database';

import akLogoTransp from './img/ak-logo-transp.svg';

const BEATS = {
    BEAT_1: 'BEAT_1',
    BEAT_2: 'BEAT_2',
    BEAT_3: 'BEAT_3',
    BEAT_4: 'BEAT_4',
    BEAT_5: 'BEAT_5',
    BEAT_6: 'BEAT_6',
    BEAT_7: 'BEAT_7'
};

interface Ifamily {
    id: string;
    familyLabel: string;
    wealthLabelLong: string;
    wealthLabelShort: string;
    wealth: number;
    scale: number;
    reduceOtherCircles: number;
}

export default class Rechner extends StoryFramework {
    database: Database;
    scales: Object;
    families: Array.<Ifamily>;

    constructor(holderSelector = '.interactive-content') {
        super('rechner', 'trackingid', `https://${window.location.host}/`, holderSelector, {
            story: {
                timePerBeat: 3000
            },
            endStory: {
                scrollToContent: false,
                showScrollDownCursor: false
            }
        });

        this.database = new Database();

        this.defineBeats();

        //  1,000,000,000 -  1.00 Bil.
        // 34,800,000,000 - 34.80 Bil
        // 14,700,000,000 - 14.70 Bil.
        //  5,750,000,000 -  5.75 Bil.
        //  5,600,000,000 -  5.60 Bil.
        this.families = [
            {
                id: 'swarovski',
                familyLabel: 'Familie Swarovski',
                wealthLabelLong: '3.600,000,000',
                wealthLabelShort: '3,6 Mrd.',
                wealth: 4100000000,
                scale: 1,
                reduceOtherCircles: 30
            },
            {
                id: 'didi',
                familyLabel: 'Dietrich Mateschitz',
                wealthLabelLong: '16.400,000,000',
                wealthLabelShort: '16,4 Mrd.',
                wealth: 14700000000,
                scale: 1,
                reduceOtherCircles: 60
            },
            {
                id: 'porsche',
                familyLabel: 'Familie Porsche Piëch',
                wealthLabelLong: '51.100.000.000',
                wealthLabelShort: '51,1 Mrd.',
                wealth: 34800000000,
                scale: 1,
                reduceOtherCircles: 120
            }
        ];
    }

    init(): void {
        let width = window.innerWidth;
        const height = window.innerHeight;

        if (width > height) {
            width = height;
        }

        width *= 0.95;

        const scaleCircle2 = 500000 / this.database.medianIncome;
        const scaleCircle3 = 2200000 / this.database.medianIncome;

        this.families[0].scale = 1;
        this.families[1].scale = this.families[0].scale * this.families[1].wealth / this.families[0].wealth;
        this.families[2].scale = this.families[1].scale * this.families[2].wealth / this.families[1].wealth;

        // Init must run after all the scales have been calculated.
        super.init();

        this.find('circle').css({
            width: `${width}px`,
            height: `${width}px`
        });

        this.find('circle-holder').css({
            width: `${width}px`,
            height: `${width}px`
        });

        this.find('circle-outer-holder').css({
            width: `${width}px`,
            height: `${width}px`
        });

        this.find('income-distribution-holder').css({
            width: `${width}px`,
            height: `${width}px`
        });

        this.find('circle-holder-billionaires').css({
            width: `${width}px`,
            height: `${width}px`
        });

        // this.find('circle-half-mil').css('transform', `scale(${scaleCircle2})`);
        // this.find('circle-2mil').css('transform', `scale(${scaleCircle3})`);

        for (let i = 0; i < this.families.length; i++) {
            const family = this.families[i];
            this.find(`circle-${family.id}`).css('transform', `scale(${family.scale})`);
        }

        // Update the zoom property for the beats.
        // this.storyBeats.get(BEATS.BEAT_3).zoom = 1 / scaleCircle2;
        // // this.storyBeats.get(BEATS.BEAT_4).zoom = 1 / scaleCircle3;
        // this.storyBeats.get(BEATS.BEAT_5).zoom = 1 / scaleCircle3;

        // this.storyBeats.get(BEATS.BEAT_4).zoom = this.roundNumber(1 / scaleCircle3);

        // this.storyBeats.get(BEATS.BEAT_4).zoomBil = 4;
        // this.storyBeats.get(BEATS.BEAT_5).zoomBil = 4;

        this.startStory();
    }


    roundNumber(number: number) {
        console.log(number)
        number = Math.round(number * 1000);
        console.log(number)
        number = number / 1000;
        console.log(number)

        return number;
    }
    bindEvents(): void {
        super.bindEvents();

        this.find('calculate-btn').on('click', evt => {
            // Stop propagating so we don't trigger a next beat.
            evt.stopPropagation();

            let formattedAmount = <string>this.find('input').val();
            if (formattedAmount === '')  {
                formattedAmount = '50000';
            };

            // Remove all . as they are separators in German.
            formattedAmount = formattedAmount.replace(/\./g, '').replace(',', '.');

            const amount = Number(formattedAmount);
            this.updateBeat2Text(amount);
            this.nextBeat();
        });

        this.find('family-btn').on('click', evt => {
            // Stop propagating so we don't trigger a next beat.
            evt.stopPropagation();

            const id = this.$(evt.target).attr('data-id');
            let familyScale = 1;
            let reduceNormalCircles = 1;
            let opacity = 0;

            // let normalCirclesScale = 0.005;

            for (let i = 0; i < this.families.length; i++) {
                const family = this.families[i];

                if (family.id === id) {
                    familyScale = family.scale;
                    reduceNormalCircles = family.reduceOtherCircles;

                    if (i > 0) {
                        opacity = 0;
                        // normalCirclesScale = 0.0025;
                    }
                }
            }



            // this.find('circle-holder').css({
            //     opacity: opacity,
            // });

            this.animateCircles(id);

            // this.find('circle-holder-billionaires').css('transform', `translate(-50%, 0%) scale(${1 / familyScale})`);
        });

        this.find('input').keypress(event => {
            const keycode = (event.keyCode ? event.keyCode : event.which);

            if (keycode === 13) {
                this.find('calculate-btn').trigger('click');
            }
        });
    }


    updateBeat2Text(income: number): void {
        let word = 'unter';

        if (income >  this.database.medianIncome) {
            word = 'über';
        }

        const diff = Math.abs(income - this.database.medianIncome);

        const beatText = `Damit liegen Sie ${this.numberFormatter.default(diff)} Euro ${word} dem mittleren Vermögen in Österreich.`;

        this.storyBeats.get(BEATS.BEAT_2).text = beatText;
    }

    getAppSpecificHtml(projectPrefix) {
        const p = projectPrefix;
        const a = this.assetLocation;

        return `
            <div class="v2">
                <img class="${p}-ak-logo" src="${akLogoTransp}"/>
                <div class="${p}-circle-outer-holder">
                    ${this.createCirclesHtml()}
                </div>

                <div class="${p}-income-distribution-holder">
                    <img class="${p}-pie ${p}-pie-39 hide" src="${a}/img/pie-chart-39.svg" />
                    <img class="${p}-pie ${p}-pie-2 hide" src="${a}/img/pie-chart-2.svg" />
                </div>

                <div class="${p}-beat1Text-holder">
                    <div class="${p}-beat1Text">
                        Wie hoch schätzen Sie Ihr Vermögen im Haushalt? Denken Sie auch an Autos, Immobilien, Grundstücke, Erspartes, etc. und ziehen Sie Schulden ab. Ihre Eingaben werden nicht gespeichert.
                    </div>

                    <div>
                        <input type="text" class="${p}-input" placeholder="50.000" />
                    </div>

                    <button class="${p}-calculate-btn">Einschätzen</button>
                </div>

                <div class="${p}-text-holder">
                    <div class="${p}-text"></div>

                    ${this.getFamilySelectionHtml(p)}
                </div>
            </div>
        `;
    }

    createCirclesHtml(): string {
        const p = this.projectPrefix;

        // let html = `<div class="${p}-circle-holder">`;
        let html = '';

        html += this.createCircleHtml('83000', '83.000', 'mittleres Vermögen');
        html += this.createCircleHtml('half-mil', '500.000', 'obere 10 %');
        html += this.createCircleHtml('2mil', '2.200.000', 'reichste 1 %');
        // html += '</div>';

        // Billionaires circles
        // html += `<div class="${p}-circle-holder-billionaires">`;
        for (let i = 0; i < this.families.length; i++) {
            const family = this.families[i];
            html += this.createCircleHtml(family.id, family.wealthLabelShort, family.familyLabel);
        }
        // html += '</div>';

        return html;
    }

    createCircleHtml(cls: string, wealth: string, sublabel: string): string {
        const p = this.projectPrefix;

        return `
            <div class="${p}-circle ${p}-circle-${cls}" data-id="${cls}">
                <div class="${p}-circle-label">
                    <div>${wealth} €</div>
                    <div class="${p}-circle-sublabel">${sublabel}</div>
                </div>
            </div>
        `;
    }

    getFamilySelectionHtml(p: string): string {
        let html = `
            <div class="${p}-family-selection-holder">
                <div class="${p}-family-selection">
        `;

        for (let i in this.families) {
            const family = this.families[i];
            html += this.createFamilySelectionbtn(family.id, family.familyLabel, family.wealthLabelShort);
        }

        html += `
                </div>
            </div>
        `;

        return html;
    }

    createFamilySelectionbtn(id: string, label: string, wealthAbr: string): string {
        const p = this.projectPrefix;

        return `
            <div class="${p}-family-btn" data-id="${id}">
                ${label}
                <br>
                ${wealthAbr}
            </div>
        `;
    }

    defineBeats() {
        this.addBeat(BEATS.BEAT_1, {
            showCircles: true,
            showPie2: false,
            showPie39: false,
            disableControls: true,
            zoom: 2
        });

        this.addBeat(BEATS.BEAT_2, {
            showCircles: true,
            showPie2: false,
            showPie39: false,
            disableControls: false,
            text: 'Damit liegen Sie unter/über dem mittleren Vermögen in Österreich. Das liegt mit [X] Euro unter/über mittleres vermögen.',
            textZindex: 1,
            zoom: 1 // Will be set dynamically later.
        });

        this.addBeat(BEATS.BEAT_3, {
            showCircles: true,
            showPie2: false,
            showPie39: false,
            disableControls: false,
            text: 'Die Vermögen der oberen zehn Prozent beginnen dagegen bei rund einer halben Million Euro.',
            textZindex: 1,
            zoom: 1 // Will be set dynamically later.
        });

        this.addBeat(BEATS.BEAT_4, {
            showCircles: true,
            showPie2: false,
            showPie39: false,
            disableControls: false,
            text: 'Das reichste Prozent der Österreicher hat mehr als 2,2 Millionen Euro auf der Seite.',
            textZindex: 1,
            zoom: 1 // Will be set dynamically later.
        });

        this.addBeat(BEATS.BEAT_5, {
            showCircles: true,
            showPie2: false,
            showPie39: false,
            disableControls: false,
            showFamilySelection: true,
            text: 'Im Vergleich zu den Superreichen ist das wenig: Wählen Sie hier, mit welchem Vermögenden Ihr Erspartes verglichen werden soll.',
            textZindex: 8, // Place above the icon overlays.
        });

        this.addBeat(BEATS.BEAT_6, {
            showCircles: false,
            showPie2: false,
            showPie39: true,
            disableControls: false,
            text: 'Dieser kleine Zirkel des reichsten Prozents verfügt über 39 Prozent des gesamten Vermögens in Österreich.',
            showIncomeDistribution: true,
            textZindex: 1,
            wealthPercentage: 39,
            populationPercentage: 1
        });

        this.addBeat(BEATS.BEAT_7, {
            showCircles: false,
            showPie2: true,
            showPie39: false,
            disableControls: false,
            text: 'Die Hälfte der Haushalte in Österreich hat aber nur 2,8 Prozent des Vermögens.',
            textZindex: 1,
            showIncomeDistribution: true,
            wealthPercentage: 2.8,
            populationPercentage: 50
        });
    }

    getLoaderCircleHtml(): string {
        return `
            <div class="add-ds-loader">
                <div>
                    <img src="${akLogoTransp}"/>
                </div>
                <div class="add-ds-loader-circles">
                    <div class="loader-circle loader-circle-1"></div>
                    <div class="loader-circle loader-circle-2"></div>
                    <div class="loader-circle loader-circle-3"></div>
                </div>
            </div>
        `;
    }

    reset() {
        super.reset();
    }

    resize() {
        super.resize();
    }

    /**
     * Setters.
     */
    setState(state, beatId, beatIndex) {
        super.setState(state, beatId, beatIndex);

        (beatId === BEATS.BEAT_1) ? this.showBeat1Text() : this.hideBeat1Text();

        (state.text) ? this.showText(state.text, state.textZindex) : this.hideText();
        (state.showFamilySelection) ? this.showFamilySelection(state.text) : this.hideFamilySelection();


        if (state.showCircles) {
            this.showCircles();
        } else {
            this.hideCircles();
        }

        if (state.showPie2) {
            this.showPie2();
        } else {
            this.hidePie2();
        }

        if (state.showPie39) {
            this.showPie39();
        } else {
            this.hidePie39();
        }

        if (state.zoom) {
            // this.setCircleZoom(state.zoom);
        }

        // if (state.zoomBil) {
        //     this.setZOomBil(state.zoomBil);
        // }

        this.animateCircles(beatId);
    }

    animateCircles(id: string): void {
        let w83 = 0;

        switch (id) {
            case BEATS.BEAT_1:
                this.changeWidthCircle('porsche', '600%');
                this.changeWidthCircle('didi', '500%');
                this.changeWidthCircle('swarovski', '400%');
                this.changeWidthCircle('half-mil', '300%');
                this.changeWidthCircle('2mil', '300%');
                this.changeWidthCircle('83000', '200%');
                break;

            case BEATS.BEAT_2:
                this.changeWidthCircle('porsche', '600%');
                this.changeWidthCircle('didi', '500%');
                this.changeWidthCircle('swarovski', '400%');
                this.changeWidthCircle('2mil', '300%');
                this.changeWidthCircle('half-mil', '200%');
                this.changeWidthCircle('83000', '100%');
                break;

            case BEATS.BEAT_3:
                this.changeWidthCircle('porsche', '500%');
                this.changeWidthCircle('didi', '400%');
                this.changeWidthCircle('swarovski', '300%');
                this.changeWidthCircle('2mil', '200%');
                this.changeWidthCircle('half-mil', '100%');
                this.changeWidthCircle('83000', '16%');
                break;

            case BEATS.BEAT_4:
            case BEATS.BEAT_5:
                this.changeWidthCircle('porsche', '400%');
                this.changeWidthCircle('didi', '300%');
                this.changeWidthCircle('swarovski', '200%');
                this.changeWidthCircle('2mil', '100%');
                this.changeWidthCircle('half-mil', '22%');
                this.changeWidthCircle('83000', '3%');
                break;

            case 'swarovski':
                this.changeWidthCircle('porsche', '300%');
                this.changeWidthCircle('didi', '200%');
                this.changeWidthCircle('swarovski', '100%');
                this.changeWidthCircle('2mil', '2%');
                this.changeWidthCircle('half-mil', '0%');
                this.changeWidthCircle('83000', '0%');

                break;

            case 'didi':
                this.changeWidthCircle('porsche', '200%');
                this.changeWidthCircle('didi', '100%');
                this.changeWidthCircle('swarovski', '28%');
                this.changeWidthCircle('2mil', '1%');
                this.changeWidthCircle('half-mil', '0%');
                this.changeWidthCircle('83000', '0%');
                break;

            case 'porsche':
                this.changeWidthCircle('porsche', '100%');
                this.changeWidthCircle('didi', '42%');
                this.changeWidthCircle('swarovski', '11%');
                this.changeWidthCircle('2mil', '0.5%');
                this.changeWidthCircle('half-mil', '0%');
                this.changeWidthCircle('83000', '0%');
                break;
        }
    }


    changeWidthCircle(id: string, size: string):void {
        this.find(`circle-${id}`).css({
            height: `${size}`,
            width: `${size}`
        });
    }

    setZOomBil(zoom: number): void {
        this.find('circle-holder-billionaires').css('transform', `translate(-50%, 0%) scale(${zoom})`);
    }

    setCircleZoom(zoom: number): void {
        this.find('circle-holder').css('transform', `translate(-50%, -50%) scale(${zoom})`);
    }

    showBeat1Text(): void {
        this.find('beat1Text-holder').show();
    }

    hideBeat1Text(): void {
        this.find('beat1Text-holder').hide();
    }

    showText(text: string, zIndex: 1): void {
        this.find('text').html(text)
        this.find('text-holder').css('z-index', zIndex).show();
    }

    hideText(): void {
        this.find('text-holder').hide();
    }

    showFamilySelection(text: string): void {
        this.find('family-selection-holder').show();
    }

    hideFamilySelection(): void {
        this.find('family-selection-holder').hide();
    }

    showCircles(): void {
        this.find('circle-outer-holder').removeClass('hide');
    }

    hideCircles(): void {
        this.find('circle-outer-holder').addClass('hide');
    }

    showPie2(): void {
        this.find('pie-2').removeClass('hide');
    }

    hidePie2(): void {
        this.find('pie-2').addClass('hide');
    }

    showPie39(): void {
        this.find('pie-39').removeClass('hide');
    }

    hidePie39(): void {
        this.find('pie-39').addClass('hide');
    }
}
